import { URL } from "../../api/Api";
import { SUBMISSION } from "../Action";
import { catchError, GET, POST, PUT } from "../axios/Axios";

export const CreateSubmissionDocument = async (id, payload={}) => {
  try {
    const response = await POST(
      `${URL}/matchengine/submission/document/${id}`,
      payload
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const SubmissionDocument = (id) => {
  return async (dispatch) => {
    try {
      const response = await GET(
        `${URL}/matchengine/submission/document/${id}`,
        {}
      );
      dispatch({ type: SUBMISSION.submission, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const CreateJustification = async (id, params) => {
  try {
    const response = await POST(
      `${URL}/matchengine/submission/summary/rewrite/${id}`,
      "",
      params
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const UpdateSubmissionDocument = async (id, data) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/submission/document/${id}`,
      data,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const VerifiedDocument = async (id, payload) => {
  try {
    const response = await POST(
      `${URL}/matchengine/share/submission-document/${id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};
